import { Component, OnInit } from '@angular/core';
import { DecryptionService } from 'src/shared/services/decryption.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { STRING_TYPE, IfStmt } from '@angular/compiler';
import { PayloadRequest } from 'src/shared/model/PayloadRequest';
import { PayLoadData } from 'src/Shared/model/PayLoadData';
import { isNullOrUndefined } from 'util';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  Data: string = "";
  base64Decoded: string = "";
  sub: any;
  page: any;
  public payloadRequest: PayloadRequest;

  constructor(
    public decryptionServiceService: DecryptionService, private router: Router, private route: ActivatedRoute, ) { }

  ngOnInit() {
    this.Data = this.route.snapshot.queryParamMap.get('data');
    console.log(this.Data);
    if (!isNullOrUndefined(this.Data)) {
      this.payloadRequest = { Data: this.Data };

      this.decryptionServiceService.Decryption(this.payloadRequest).subscribe((data: PayLoadData) => {
        console.log(data);
        if (!isNullOrUndefined(data.employeeNo) && data.employeeNo != '') {
          if (data.showPosition <= data.position) {
           // if (1 <= data.position) {
              if(data.location.endsWith(','))
            {
              data.location= data.location.slice(0,-1);
            }
            if (data.city != null && data.city != undefined && data.city != '') {
              data.location = data.location + ", " + data.city;
            }
            if (data.pincode != null && data.pincode != undefined && data.pincode != '') {
              data.location = data.location + ", " + data.pincode;
            }
            if(data.location.startsWith(','))
            {
              data.location= data.location.slice(1);
            }
            sessionStorage.setItem('data', JSON.stringify(data));
            if (data.is_Submited == "1") {
              this.router.navigate(['/thankyou']);
            } else {
              this.router.navigate(['/show']);
            }
          }
          else {
            this.router.navigate(['/unauthorize']);
          }
        } else {
          this.router.navigate(['/unauthorize']);
        }
      });
      this.router.navigate(['/unauthorize']);
    }
    else {
      this.router.navigate(['/unauthorize']);
    }

  }
}
